import BunchDbPluginSettings from "./components/ModalWindow/BunchDB/BuchDbPluginSettings"
import SettingsAdditionalPluginSettings from "./components/ModalWindow/SettingsAdditional/SettingsAdditionalPluginSettings"

const CashRegistersPluginSettings: IPluginSettings = {
    name: 'Кассовые аппараты',
    mnemocode: 'cash_registers_plugin',
    permission: 'CashRegister',
    columns: [
        {
            order: 0,
            propertyName: 'idGlobal',
            propertyType: 'string',
            displayName: 'idGlobal',
            visibility: false,
            width: 100
        }, {
            order: 1,
            propertyName: 'idCashRegister',
            propertyType: 'string',
            displayName: 'ID кассы',
            visibility: true,
            width: 157
        }, {
            order: 2,
            propertyName: 'nameCashRegister',
            propertyType: 'string',
            displayName: 'Наименование',
            visibility: true,
            width: 167
        },
        {
            order: 3,
            propertyName: 'numberCashRegister',
            propertyType: 'number',
            displayName: 'Номер ККМ',
            visibility: true,
            width: 157
        }, 
        {
            order: 4,
            propertyName: 'posVersion',
            propertyType: 'string',
            displayName: 'Версия F3POS',
            visibility: true,
            width: 157
        }, 
        {
            order: 5,
            propertyName: 'contractorName',
            propertyType: 'string',
            displayName: 'Контрагент',
            visibility: true,
            width: 167
        }, 
        {
            order: 6,
            propertyName: 'companyId',
            propertyType: 'string',
            displayName: 'Guid компании',
            visibility: true,
            width: 177
        }, 
        {
            order: 7,
            propertyName: 'dateCreated',
            propertyType: 'datetime',
            displayName: 'Дата создания',
            visibility: true,
            width: 167
        },
        {
            order: 8,
            propertyName: 'dateModified',
            propertyType: 'datetime',
            displayName: 'Дата изменения',
            visibility: true,
            width: 167
        },
        {
            order: 9,
            propertyName: 'dateDeleted',
            propertyType: 'datetime',
            displayName: 'Дата удаления',
            visibility: true,
            width: 167
        },
        {
            order: 10,
            propertyName: 'idAccessPointGlobal',
            propertyType: 'string',
            displayName: 'Ид точки доступа',
            visibility: false,
            width: 167
        },
        {
            order: 11,
            propertyName: 'availableF3PosVersion',
            propertyType: 'string',
            displayName: 'Доступная версия F3POS',
            visibility: true,
            width: 167
        },
        {
            order: 12,
            propertyName: 'isAutoUpdate',
            propertyType: 'boolean',
            displayName: 'Автоматическое применение обновлений',
            visibility: true,
            width: 167
        },
    ],
    detailsPlugins: [
        BunchDbPluginSettings,
        SettingsAdditionalPluginSettings
    ]
}

export default CashRegistersPluginSettings
